import { formatDecimal } from 'framework/utils';

export const TEAM_COVERAGE_TOOLTIP = 'required FTE (actual FTE / planned FTE)';

type TeamCoverageStats = {
  value: string;
};

export const getTeamCoverageStats = (
  assignedFte?: number | null,
  plannedFte?: number | null,
): TeamCoverageStats | null => {
  if (assignedFte == null || plannedFte == null) {
    return null;
  }

  const gap = Math.max(plannedFte - assignedFte, 0);

  return {
    value: `${formatDecimal(gap)} FTE (${formatDecimal(assignedFte)} / ${formatDecimal(plannedFte)})`,
  };
};
